module.exports = __webpack_public_path__ + "h5/img/heziHei.3841d1a7.png";